import React from "react";
import {
    DeliveryTruckIcon,
    DeliveryTruckIconGray,
    DollarGray,
    DollarWhite,
    GlobeIcon,
    PaperIcon,
    PaperIconWhite,
    ShadowUnderIcons,
    WorldWhite,
} from "../../assets/icons";
import {useLanguage} from "../../hooks/LanguageContext";

const Tabs = ({ handleTab, activeTab }) => {
	const { direction } = useLanguage(); // Access the language direction

	const tabsContent = [
		{
			id: 4,
			iconGray: <DollarGray className="w-8  md:w-auto" />,
			iconWhite: <DollarWhite className="w-8  md:w-auto" />,
			title: direction === "rtl" ? "اسعار الشحن" : "Shipping Prices",
		},
		{
			id: 3,
			iconGray: <GlobeIcon className="w-8  md:w-auto" />,
			iconWhite: <WorldWhite className="w-8  md:w-auto" />,
			title: direction === "rtl" ? "مواقع فروعنا" : "Our Branches",
		},
		{
			id: 2,
			iconGray: <PaperIcon className="w-8 md:w-auto" />,
			iconWhite: <PaperIconWhite className="w-8 md:w-auto" />,
			title: direction === "rtl" ? "الحجز السريع" : "Quick Booking",
		},
		{
			id: 1,
			iconWhite: <DeliveryTruckIcon className="w-8  md:w-auto" />,
			iconGray: <DeliveryTruckIconGray className="w-8  md:w-auto" />,
			title: direction === "rtl" ? "تتبع سيارتك" : "Track Your Car",
		},



	];

	return (
		<div
			className={`absolute -top-6 -translate-y-1/2 left-1/2 -translate-x-1/2 w-full mx-auto  flex items-center justify-center  flex-row-reverse
			 xl:gap-[20px] gap-0.5 md:gap-2 `}
		>
			{tabsContent.map((tab) => (
				<button
					key={tab.id}
					onClick={() => handleTab(tab.id)}
					className={` w-[70%] h-[60px] md:h-[90px] lg:h-[100px]  flex items-center md:rounded-[20px] rounded-xl md:py-3 md:px-3 shadow transition-colors duration-300 ${
						activeTab === tab.id ? "bg-primary-700" : "bg-bg-light"
					}`}
				>
					{/* Icon Section */}
					<div
						className={`h-[20px] w-[20px] md:h-[60px] md:w-[60px] rounded-full flex flex-col items-center justify-center shadow-inner transition-colors duration-300 ${
							activeTab === tab.id ? "bg-primary-700" : "bg-bg-light"
						}`}
					>
						{activeTab === tab.id ? tab.iconWhite : tab.iconGray}
						<ShadowUnderIcons />
					</div>

					{/* Text Section */}
					<div className="ml-4 flex-grow">
						<p
							className={`headline-5-ar !text-sm md:!text-2xl md:headline-3-ar whitespace-nowrap text-center transition-colors duration-300 ${
								activeTab === tab.id ? "text-bg-light" : "text-grayscale-400"
							}`}
						>
							{tab.title}
						</p>
					</div>
				</button>

			))}
		</div>
	);
};

export default Tabs;